<template>
  <div>
    <table class="table is-striped is-hoverable is-fullwidth is-size-7">
      <tr>
        <th>Operation Id</th>
        <th>Operation Type</th>
        <th>Operation Amount</th>
        <th>Operation Currency</th>
        <th>User Id</th>
        <th>User Name</th>
        <th></th>
      </tr>
      <tr v-for="{ operation, user } of operations">
        <td>{{ operation.id }}</td>
        <td>{{ operation.type }}</td>
        <td>{{ operation.amount | currency(operation.currency) }}</td>
        <td>{{ operation.currency }}</td>
        <td>{{ user.id }}</td>
        <td>{{ user.username }}</td>
        <td>
          <a href="javascript:void(0);" class="link has-text-link" @click="openDialog({ operation, user });">Details</a>
        </td>
      </tr>
    </table>
    <div v-if="!operations.length">
      No Operations
    </div>
    <div v-show="selectedItem" class="modal" ref="modal">
      <template v-if="selectedItem">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Operation ID: {{ selectedItem.operation.id }}</p>
            <button class="delete" aria-label="close" @click="closeDialog();"></button>
          </header>
          <section class="modal-card-body">
            <div>
              Operation
              <pre>{{ selectedItem.operation }}</pre>
            </div>
            <div>
              User
              <pre>{{ selectedItem.user }}</pre>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-link is-warning" @click="applyAction('Decline');">Decline</button>
            <button class="button is-link is-danger" @click="applyAction('Approve');">Approve</button>
            <label class="checkbox">
              <input v-model="selectedItem.setDefault" :checked="false" type="checkbox" ref="defaultAction"> Remember the choice
            </label>
            <button class="button" style="margin-left: auto;" @click="closeDialog();">Cancel</button>
          </footer>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import paymentSystemService from "../../services/paymentSystem.service";

  export default {
    name: "operatons-awaiting-antifraud",
    $_veeValidate: { validator: "new" },
    data: () => ({
      operations: [],
      selectedItem: null
    }),
    computed: {
      clientId: function() {
        return this.$route.params.clientId;
      }
    },
    mounted() {
      this.loadOperations();
    },
    methods: {
      async loadOperations() {
        this.operations.length = 0
        this.operations.push(...(await paymentSystemService.getOperationsAwaitingAntiFraudAsync({ clientId: this.clientId })));
      },
      openDialog(item = { operation, user }) {
        this.selectedItem = item;
        this.$refs.modal.classList.add("is-active");
      },
      closeDialog() {
        this.selectedRequest = null;
        this.$refs.modal.classList.remove("is-active");
      },
      async applyAction(action) {
        this.closeDialog();
        await paymentSystemService.applyAntiFraudActionAsync({ clientId: this.clientId, operationId: this.selectedItem.operation.id, action, setDefault: this.selectedItem.setDefault });
        this.loadOperations();
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/payment-system/operations-awaiting-antifraud.vue